<div class="min-h-screen flex flex-col bg-gray-50">
  <app-auth-header></app-auth-header>

  <div class="flex-1 flex items-center justify-center bg-gradient-to-br from-jamaica-green-600 to-jamaica-green-900 p-6">
    <div class="w-full max-w-md">
      <div class="bg-white rounded-xl shadow-2xl p-8">
        <!-- Logo -->
        <div class="text-center mb-6">
          <img
            src="/logos/wsy-yardBull-Icon.png"
            alt="Wall St Yardie Logo"
            class="h-16 w-16 mx-auto mb-4"
          />
          <h1 class="text-3xl font-bold text-gray-900 mb-2">
            Welcome to Wall St Yardie!
          </h1>
          <p class="text-gray-600">
            Please complete your profile to get started
          </p>
        </div>

        <!-- Profile Form -->
        <form
          [formGroup]="profileForm"
          (ngSubmit)="onSubmit()"
          class="space-y-6"
        >
          <!-- First Name Field -->
          <div>
            <label
              for="firstName"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              First Name *
            </label>
            <input
              id="firstName"
              type="text"
              formControlName="firstName"
              placeholder="Enter your first name"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-jamaica-green-500 focus:border-transparent transition-colors"
              [class.border-red-500]="firstName?.invalid && firstName?.touched"
            />
            @if (firstName?.invalid && firstName?.touched) {
              <p class="mt-1 text-sm text-red-600">
                @if (firstName?.errors?.["required"]) {
                  First name is required
                } @else if (firstName?.errors?.["minlength"]) {
                  First name must be at least 2 characters
                }
              </p>
            }
          </div>

          <!-- Last Name Field -->
          <div>
            <label
              for="lastName"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              Last Name *
            </label>
            <input
              id="lastName"
              type="text"
              formControlName="lastName"
              placeholder="Enter your last name"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-jamaica-green-500 focus:border-transparent transition-colors"
              [class.border-red-500]="lastName?.invalid && lastName?.touched"
            />
            @if (lastName?.invalid && lastName?.touched) {
              <p class="mt-1 text-sm text-red-600">
                @if (lastName?.errors?.["required"]) {
                  Last name is required
                } @else if (lastName?.errors?.["minlength"]) {
                  Last name must be at least 2 characters
                }
              </p>
            }
          </div>

          <!-- Marketing Consent -->
          <div class="flex items-start space-x-3">
            <input
              id="marketingConsent"
              type="checkbox"
              formControlName="marketingConsent"
              class="mt-1 h-4 w-4 text-jamaica-green-600 focus:ring-jamaica-green-500 border-gray-300 rounded"
            />
            <label for="marketingConsent" class="text-sm text-gray-700">
              I would like to receive marketing emails and product news from
              Wall St Yardie
            </label>
          </div>

          <!-- Terms and Privacy Policy -->
          <div class="text-sm text-gray-600">
            By continuing, you agree to our
            <a
              routerLink="/terms"
              target="_blank"
              class="text-jamaica-green-600 hover:text-jamaica-green-700 underline"
              >Terms of Service</a
            >
            and
            <a
              routerLink="/privacy"
              target="_blank"
              class="text-jamaica-green-600 hover:text-jamaica-green-700 underline"
              >Privacy Policy</a
            >.
          </div>

          <!-- Error Message -->
          @if (error) {
            <div class="bg-red-50 border border-red-200 rounded-lg p-4">
              <div class="flex items-center">
                <i class="fa-solid fa-exclamation-circle text-red-600 mr-3"></i>
                <span class="text-red-800">{{ error }}</span>
              </div>
            </div>
          }

          <!-- Action Buttons -->
          <div class="space-y-3 pt-4">
            <button
              type="submit"
              [disabled]="profileForm.invalid || loading()"
              class="w-full bg-jamaica-green-600 hover:bg-jamaica-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-6 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-jamaica-green-500 focus:ring-offset-2"
            >
              @if (loading()) {
                <i class="fa-solid fa-spinner fa-spin mr-2"></i>
                Saving...
              } @else {
                Continue
              }
            </button>

            <button
              type="button"
              (click)="onSkip()"
              class="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              Skip for now
            </button>

          </div>
        </form>
      </div>
    </div>
  </div>
  <app-auth-footer></app-auth-footer>
</div>
